export function countKeys(candidates) {
  return Object.keys(candidates).length
}
